import { WorkoutProgress } from "./workout_progress";
import { dateIsToday } from "../global/utils";
import { Routine } from "./routine";
import { Exercise } from "./exercise";
import { calculateRepsFromDate } from '../global/utils';

export default class Workout {
    constructor(
        data={
            id: -1,
            durationDays:0,
            daysDone:0,
            startDate:'',
            lastUpdated:'',
            updatedToday:false,
            routines:[]
        }
    ) {
        this.id = data.id;
        this.durationDays = data.durationDays;
        this.daysDone = data.daysDone;
        this.startDate = data.startDate;
        this.lastUpdated = data.lastUpdated;
        this.updatedToday = data.updatedToday;
        this.routines = [];
        this.progress = undefined;

        this.createWorkoutProgress();
        this.calculateUpdatedToday();

        if ( data.routines ) {
            this.createRoutines(data.routines);
        }
    }

    getId() {
        return this.id;
    }

    getDurationDays() {
        return this.durationDays;
    }

    getDaysDone() {
        return this.daysDone;
    }

    getStartDate() {
        return this.startDate;
    }

    getLastUpdated() {
        return this.lastUpdated;
    }

    getUpdatedToday() {
        return this.updatedToday;
    }

    getRoutines() {
        return this.routines;
    }

    createWorkoutProgress() {
        this.progress = new WorkoutProgress(
                            this.daysDone, 
                            this.durationDays, 
                            this.lastUpdated
        );
    }
    
    calculateUpdatedToday() {
        this.updatedToday = this.lastUpdated ? dateIsToday(this.lastUpdated) : false;
    }

    createRoutines(routines=[]) {
        routines.forEach(data => {
            const exercise = new Exercise(data.exercise.id, data.exercise.title);
            const routine = new Routine(data.id, exercise, data.reps, data.coefficient, data.weight);

            if ( this.progress.daysDone > 0 ) {
                routine.calculatedReps = this.calculateDailyReps(routine)
            }

            this.routines.push(routine);
        });
    }

    calculateDailyReps(routine) {
        return calculateRepsFromDate(routine.reps, routine.coefficient, this.progress.daysDone);
    }

    isComplete() {
        return this.progress.getComplete();
    }
}